import { RadioWrapper } from '../../../../../radio/RadioWrapper';
import { RadioGroupComponent } from '../../../../../radio/RadioGroup';

interface CreateNewDestinationRadioGroupProps {
  currentValue: 'true' | 'false';
  defaultValue: 'true' | 'false';
  onChange: (value: string) => void;
}

export function PipelineCreateNewDestinationRadioGroup({
  currentValue,
  defaultValue,
  onChange
}: CreateNewDestinationRadioGroupProps) {
  return (
    <div className='pt-7 pb-2'>
      <RadioGroupComponent
        name='createNewDestination'
        currentValue={currentValue}
        defaultValue={defaultValue}
        onChange={onChange}
      >
        <RadioWrapper
          dataId='select-existing-destination'
          radioProps={{ value: 'false' }}
          label='Select Existing Destination'
        />

        <RadioWrapper
          dataId='create-new-destination'
          radioProps={{ value: 'true' }}
          className='ml-9'
          label='Create New Destination'
        />
      </RadioGroupComponent>
    </div>
  );
}
